/**
 * Dashboard - point d'entree apres connexion.
 * Affiche les campagnes (MJ) et les personnages (joueur).
 */

import type { AuthUser } from '@services/auth';
import { pocketbaseAuth } from '@services/pocketbase-auth';
import { html } from 'lit';
import { buildHref, navigate } from '../router';

export async function renderDashboardPage(user: AuthUser): Promise<unknown> {
  async function handleSignOut() {
    await pocketbaseAuth.signOut();
    navigate('login');
  }

  const displayName = user.displayName ?? user.email.split('@')[0];

  return html`
    <div class="dashboard">
      <header class="dashboard-header">
        <h1 class="dashboard-greeting">
          Bienvenue, <strong>${displayName}</strong>
        </h1>
        <div class="dashboard-user">
          <button class="dashboard-signout" @click=${handleSignOut}>
            Deconnexion
          </button>
        </div>
      </header>

      <div class="dashboard-sections">
        <section class="dashboard-section">
          <span class="dashboard-badge">Personnages</span>
          <h2 class="dashboard-section-title">Mes aventuriers</h2>
          <p class="dashboard-section-desc">
            Creez et gerez vos personnages. Chaque heros a son histoire.
          </p>
          <div class="dashboard-actions">
            <a class="dashboard-btn dashboard-btn-primary" href=${buildHref('personnage-new')}>
              + Nouveau
            </a>
            <a class="dashboard-btn dashboard-btn-secondary" href=${buildHref('personnage')}>
              Voir tous
            </a>
          </div>
        </section>

        <section class="dashboard-section dashboard-section-locked">
          <span class="dashboard-badge">Campagnes</span>
          <h2 class="dashboard-section-title">Table de jeu</h2>
          <p class="dashboard-section-desc">
            Rejoignez ou creez une campagne pour jouer en ligne avec votre groupe. Bientot disponible.
          </p>
        </section>
      </div>
    </div>
  `;
}
